import React from 'react';

const Privacy = () => (
  <div style={{ maxWidth: 840, margin: '40px auto', padding: '0 16px' }}>
    <h1>Privacy & Cookies</h1>
    <p>
      This placeholder privacy notice describes how talkabout.finance uses cookies and analytics to
      improve your experience. Update this page with your full privacy policy and data practices.
    </p>
    <h2>Cookies & Analytics</h2>
    <p>
      We use cookies to remember your preferences (including cookie consent) and, if you accept,
      to run analytics via Google Tag Manager. Declining cookies disables analytics.
    </p>
    <h2>Your Choices</h2>
    <p>
      You can accept or decline analytics cookies via the cookie banner. You may clear or change
      your choice by clearing site data in your browser or updating this page with a dedicated
      settings link.
    </p>
  </div>
);

export default Privacy;
